import * as types from '../../actionTypes';

const initialState = {
    patientDndInfo: [],
    error: {},
    loading: false
}


export const patientDndReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.PATIENT_DND_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.PATIENT_DND_SUCCESS:
            console.log("action.payload",action.payload)
            return {
                ...state,
                patientDndInfo: action.payload,
                loading: false,
                error: {}
            }
        case types.PATIENT_DND_FAIL:
            return{
                ...state,
                error: action.payload,
                loading: false,
            } 


        default:
            return state;
    }
}